import React from 'react';
import TopBar from '../../../layout/TopBar';
import JurisprudenceFollow from '../components/JurisprudenceFollow';
import JurisprudenceTabs from '../components/JurisprudenceTabs';

const JurisprudenceSuiviPage = () => {
  return (
    <div className="min-h-screen bg-mcdm-primary-200 dark:bg-mcdm-third-500 pb-10">
      <TopBar />
      <div className="pt-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="">
            <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:justify-between sm:items-center mb-6">
              <h1 className="text-2xl font-platypi text-mcdm-third-500 dark:text-mcdm-primary-100">
                Jurisprudences
              </h1>
            </div>

            <JurisprudenceTabs active="follows" />

            <JurisprudenceFollow />
          </div>
        </div>
      </div>
    </div>
  );
};

export default JurisprudenceSuiviPage;
